import { componentStyles, useColors } from "@mallardbay/lib-react-components"

export function useSharedStyles({ isActiveItem }: { isActiveItem?: boolean }) {
    const colors = useColors()
    const color = isActiveItem ? colors.brandDefault : colors.secondaryText
    const opacity = isActiveItem ? 1 : 0.9

    return componentStyles({
        activeBar: {
            width: "4px",
            height: "42px",
            left: "0",
            position: "absolute",
            bgColor: colors.brandDefault,
        },
        label: {
            paddingTop: "2px",
            fontSize: "14px",
            fontWeight: 700,
            color,
            transition: "width .3s",
            noOfLines: 1,
            opacity,
        },
    })
}
